module.exports = "../../../../platform/assets/pageMainIcon/cd-date-date.svg";